import Constants from "../Constants.js";
import Analyzer from "./Analyzer.js";
const {
  LOGGED_IN
} = Constants;
export default {
  install(molten) {
    molten.addPlugin(LOGGED_IN, Analyzer);
  }
};